import { createAction, props } from '@ngrx/store';
import { SystemError } from 'src/app/shared/models/SystemError';
import { TextValue } from '../../analysis/models/criterions/TextValue';
import { AppFeature } from '../app-feature/app-feature';
import { GetAppContext } from '../auth/GetAppContext';
import { OAuthProperties } from '../auth/auth.service';
import { Tooltip } from '../tooltip/Tooltip';
import { UserPopupPrefs } from 'src/app/user-admin/user/models/UserPopupPrefs';
import { Analysis } from '../../analysis/models/Analysis';

export enum ActionTypes {
    INVALIDATE_SESSION = '[Logout Invalidate Session] Invalidate user session in backend',
    INVALIDATE_SESSION_SUCCESS = '[Logout Invalidate Session] Successfully invalidated user session in backend',
    INVALIDATE_SESSION_FAIL = '[Logout Invalidate Session] Failed to invalidate user session in backend',
    LOAD_APP_CONTEXT = '[AppContext] Load appContext',
    LOAD_APP_CONTEXT_SUCCESS = '[AppContext API] appContext data was fetched successfully',
    LOAD_APP_CONTEXT_FAIL = '[AppContext API] appContext data failed',
    LOAD_OAUTH_PROPERTIES_SUCCESS = '[WebEAM OAuth API] OAuth Properties loaded successfully',
    LOAD_OAUTH_PROPERTIES_FAIL = '[WebEAM OAuth API] OAuth Properties failed to load',
    SEARCH_TOOLTIPS = '[TOOLTIP API] Search tooltips',
    SEARCH_TOOLTIPS_SUCCESS = '[TOOLTIP API] tooltips fetched successfully',
    SEARCH_TOOLTIPS_FAIL = '[TOOLTIP API] tooltips failed to load',
    TOAST_SUCCESS = '[TOAST SUCCESS] Toast was shown with success',
    TOAST_WARNING = '[TOAST WARNING] Toast was shown with warning',
    TOAST_ERROR = '[TOAST ERROR] Toast was shown with error',
    TOAST_INFO = '[TOAST INFO] Toast was shown with info',
    GET_APP_FEATURES_SUCCESS = '[AppFeature API] Successfully get all features',
    GET_APP_FEATURES_FAIL = '[AppFeature API] Failed to get all features',
    REDIRECT_TO_MY_WORKPLACE_IF_APPLICABLE_SUCCESS = '[MyWorkplace] Redirect to my workplace, if applicable, successful',
    REDIRECT_TO_MY_WORKPLACE_IF_APPLICABLE_FAIL = '[MyWorkplace] Redirect to my workplace, if applicable, failed',
    GET_EXTERNAL_HELP_LINK = '[HELP PAGES] Get external help link',
    GET_EXTERNAL_HELP_LINK_SUCCESS = '[HELP PAGES SUCCESS] External help link fetched successfully',
    COPY_CURRENT_URL_TO_CLIPBOARD = '[Core] Copying current URL to clipboard',
    LOAD_INITILAIZER_DATA = '[AppInitializer] Load initializer data',
    DIALOG_WITH_UUID = '[Core] Display error dialog with UUID',
    ADD_USER_POPUP_PREF = '[Core] Add user popup pref',
    ADD_USER_POPUP_PREF_SUCCESS = '[Core] Add user popup pref success',
    ADD_USER_POPUP_PREF_FAIL = '[Core] Add user popup pref fail',
    GET_NEW_FROM_CLIPBOARD = '[Analysis] Create new analysis from clipboard',
    GET_NEW_FROM_CLIPBOARD_LOADED = '[Analysis] Analysis from clipboard loaded',
    GET_NEW_FROM_CLIPBOARD_SUCCESS = '[Analysis] Create new analysis from clipboard success',
    GET_NEW_FROM_CLIPBOARD_FAIL = '[Analysis] Create new analysis from clipboard fail'
}

export const invalidateSession = createAction(ActionTypes.INVALIDATE_SESSION);

export const invalidateSessionSuccess = createAction(ActionTypes.INVALIDATE_SESSION_SUCCESS);

export const invalidateSessionFail = createAction(ActionTypes.INVALIDATE_SESSION_FAIL);

export const loadAppContext = createAction(ActionTypes.LOAD_APP_CONTEXT);

export const loadAppContextSuccess = createAction(ActionTypes.LOAD_APP_CONTEXT_SUCCESS, props<{ appContext: GetAppContext }>());

export const loadAppContextFail = createAction(ActionTypes.LOAD_APP_CONTEXT_FAIL);

export const loadOAuthPropertiesSuccess = createAction(ActionTypes.LOAD_OAUTH_PROPERTIES_SUCCESS, props<{ oAuthProperties: OAuthProperties }>());

export const loadOAuthPropertiesFail = createAction(ActionTypes.LOAD_OAUTH_PROPERTIES_FAIL);

export const searchTooltips = createAction(ActionTypes.SEARCH_TOOLTIPS);

export const searchTooltipsSuccess = createAction(ActionTypes.SEARCH_TOOLTIPS_SUCCESS, props<{ tooltips: Tooltip[] }>());

export const searchTooltipsFail = createAction(ActionTypes.SEARCH_TOOLTIPS_FAIL);

export const displayToastSuccess = createAction(ActionTypes.TOAST_SUCCESS, props<{ message: string; detail?: string }>());

export const displayToastWarning = createAction(ActionTypes.TOAST_WARNING, props<{ message: string; detail?: string }>());

export const displayToastInfo = createAction(ActionTypes.TOAST_INFO, props<{ message: string; detail?: string }>());

export const displayToastError = createAction(ActionTypes.TOAST_ERROR, props<{ message: string; detail?: string }>());

export const getAppFeaturesSuccess = createAction(ActionTypes.GET_APP_FEATURES_SUCCESS, props<{ appFeatures: AppFeature[] }>());

export const getAppFeaturesFail = createAction(ActionTypes.GET_APP_FEATURES_FAIL, props<{ systemError: SystemError }>());

export const redirectToMyWorkplaceIfApplicableSuccess = createAction(ActionTypes.REDIRECT_TO_MY_WORKPLACE_IF_APPLICABLE_SUCCESS);

export const redirectToMyWorkplaceIfApplicableFail = createAction(ActionTypes.REDIRECT_TO_MY_WORKPLACE_IF_APPLICABLE_FAIL);

export const getExternalHelpLink = createAction(ActionTypes.GET_EXTERNAL_HELP_LINK, props<{ key: string }>());

export const getExternalHelpLinkSuccess = createAction(ActionTypes.GET_EXTERNAL_HELP_LINK_SUCCESS, props<{ key: TextValue }>());

export const copyUrlToClipboard = createAction(ActionTypes.COPY_CURRENT_URL_TO_CLIPBOARD, props<{ url: string }>());

export const loadInitializerData = createAction(ActionTypes.LOAD_INITILAIZER_DATA, props<{ currentUrl: string }>());

export const displayErrorDialogWithUUID = createAction(ActionTypes.DIALOG_WITH_UUID, props<{ title: string; uuid: string }>());

export const addUserPopupPref = createAction(ActionTypes.ADD_USER_POPUP_PREF, props<{ popupKey: string }>());

export const addUserPopupPrefSuccess = createAction(ActionTypes.ADD_USER_POPUP_PREF_SUCCESS, props<{ userPopupPrefs: UserPopupPrefs }>());

export const addUserPopupPrefFail = createAction(ActionTypes.ADD_USER_POPUP_PREF_FAIL, props<{ systemError: SystemError }>());

export const newFromClipboard = createAction(ActionTypes.GET_NEW_FROM_CLIPBOARD);

export const newFromClipboardLoaded = createAction(ActionTypes.GET_NEW_FROM_CLIPBOARD_LOADED, props<{ analysis: Analysis }>());

export const newFromClipboardSuccess = createAction(ActionTypes.GET_NEW_FROM_CLIPBOARD_SUCCESS, props<{ analysis: Analysis }>());

export const newFromClipboardFail = createAction(ActionTypes.GET_NEW_FROM_CLIPBOARD_FAIL, props<{ systemError: SystemError }>());
